import React, { PropsWithChildren } from 'react';
import { defaultCssVariables } from 'core/styled';
import { InputContainer, UnstyledInputDiv } from './Input.style';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as Danger } from './danger.svg';

export type Props = PropsWithChildren<{
    error?: string;
    disabled?: boolean;
    isTouched?: boolean;
}>;

export const InputWrapper: React.FunctionComponent<Props> = ({
    children,
    error,
    disabled,
    isTouched,
}) => {
    return (
        <div style={{ opacity: disabled ? 0.4 : 1 }}>
            <InputContainer error={error} isTouched={isTouched}>
                <UnstyledInputDiv>{children}</UnstyledInputDiv>
                {error && (
                    <div>
                        <div data-tip data-for="error">
                            <Danger color={defaultCssVariables.color.bloodyMary} />
                        </div>
                    </div>
                )}
                {!error && isTouched && (
                    <div data-tip data-for="touched">
                        <Check color={defaultCssVariables.color.emerald} />
                    </div>
                )}
            </InputContainer>
        </div>
    );
};
